import { Component, Input, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import { PageEvent } from "@angular/material/paginator";
import { BaseComponent, ActionDialog } from "../../../base-module/base-component/base.component";
import { AuthService } from "app/base-module/base-service/auth.service";
import { CadastroProdutoComponent } from "../cadastro-produto/cadastro-produto.component";
import { ClienteFundoInvestimentoService } from "app/clientes/services/cliente-fundo-investimento.service";
import { CadastroBoletaFundoComponent } from "app/renda-fixa/cadastro-boleta-fundo/cadastro-boleta-fundo.component";
import { MigracaoService } from "app/clientes/services/migracao.service";

@Component({
    selector: "app-cliente-fundo-investimento",
    templateUrl: "./cliente-fundo-investimento.component.html",
    styleUrls: ["./cliente-fundo-investimento.component.scss"],
    providers: [MigracaoService]
})

export class ClienteFundoInvestimentoComponent extends BaseComponent implements OnInit{

    user: any;        data_atualizacao: any;
    @Input() cliente_id!: number;

    constructor(public _service: ClienteFundoInvestimentoService, 
                private _serviceMigracao: MigracaoService,
                public dialog: MatDialog,
                override snackBar: MatSnackBar,
                private _authService: AuthService) {
        super(dialog, snackBar);

        const strUser = this._authService.getUser();
        this.user = JSON.parse(strUser? strUser : "{}");
        this.params.per_page = this.pageSize;
    }

    ngOnInit(){

        this.pageSize = 5;
        this.pageSizeOptions = [5, 10, 20, 30];
        this.getAll();
    }

    /**
     * Evento da paginação
     * @param {PageEvent} event
     */
    pageEvent(event:PageEvent){

        this.params.page = (event.pageIndex+1);
        this.params.per_page = event.pageSize;

        this.getAll();
    }

    
    /**
     * Evento de ordenação da lista de produtos
     * @param event
    */
    onSort(event:any){
        this.params.sortColumn = event.column.prop;
        this.params.sortOrder = event.newValue;

        this.getAll();
    }
  

    /**
     * Consulta lista de empresas
     */
    getAll() {

        this.loadingIndicator   = true;
        this.params.cliente_id  = this.cliente_id;

        this._service.getAll(this.params).subscribe(
            data => {
                this.length = data.meta.total;
                this.rows = data.data;
                this.temp = [...this.rows];
            },
            error => {
                console.log("error: " + error);
                this.loadingIndicator = false;
            },
            () => {

                console.log("complete");
                this.loadingIndicator = false;
            }
        );
    }

    alterar(id:any): void {
        const dialogRef = this.dialog.open(CadastroProdutoComponent, {
            width: "400px",            
            data: {                
                id: id,
                titulo: "Alterar Boleta Fundo de Investimento",
                service: this._service
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != undefined && result != null && result != "cancel"){
                this.showSuccess("Fundo de Investimento atualizado com sucesso!");
                this.getAll();
            }else if(result != undefined && result != "cancel"){
                this.showError("Ocorreu um erro ao tentar atualizar o registro.");
            }
        });
    }

    
    delete(id: number) {

        const lista = this;
        this.dialog.open(ActionDialog, {
            width: "250px",
            disableClose: true,
            panelClass: "modal-delete",
            data: {
                title: "Excluir Fundo de Investimento",
                text: "Deseja realmente excluir este item?",
                callback: function () {
                    lista.dialog.closeAll();

                    lista.loadingIndicator = true;
                    lista._service.delete(id).subscribe(
                        data => {
                            lista.loadingIndicator = false;
                            lista.showSuccess(data.message);
                            lista.getAll();
                        },
                        error => {
                            lista.loadingIndicator = false;                            
                            lista.showError(error.error.message);

                        },
                        () => {
                            console.log("complete");
                            lista.loadingIndicator = false;
                        }
                    );
                }
            }
        });
    }  

    orgaoEmissor(row:any){
        
        if (row.caracteristica.orgao_emissor != undefined && row.caracteristica.orgao_emissor != ""){
            return row.caracteristica.orgao_emissor.nome;
        }
        
        return "";
    }

    getVerificado(row:any){
        if(row.verificado_migracao){
             return "SIM";
        }else{
             return "NÃO";
        }    
    }

    getCnpj(row:any){
        if(row.caracteristica.cnpj != undefined){
            return row.caracteristica.cnpj;
        }
        
        return "";
    }

    openCadastro(){        
        const dialogRef = this.dialog.open(CadastroBoletaFundoComponent, {
            width: "800px",
            data: {
                acao_comercial_id: null,
                cliente_id: this.cliente_id,
                id: null
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {            
            if (result != undefined && result != null && result != "cancel"){
                this.showSuccess("Boleta Fundo de Investimento cadastrada com sucesso!");
                this.getAll();
            }else if(result != undefined && result != "cancel"){
                this.showError("Ocorreu um erro ao tentar cadastrar um nova boleta fundo de investimento.");
            }
        });        
    }

    getFundoInvestimento(row:any){
        
        if(row.fundo_investimento.tipo != undefined){
            return row.fundo_investimento.tipo.nome;
        }

        return "";
    }

    gerarStvm(){
        this.openLoading();
        this._serviceMigracao.gerarStvmFundo(this.params).subscribe(
            data => {
                const blob = new Blob([data], { type: "application/pdf" });
                const url = window.URL.createObjectURL(blob);
                window.open(url, "_blank");
            },
            error => {                          
                this.showError("Não foi possivel gerar a STVM, por favor verifique o CPF, Endereço e se a(s) custódia(s) esta(ão) verificada(s)");                
                this.closeLoading();
            },
            () => {
                console.log("complete");
                this.closeLoading();
            }
        );
    }
}
